import { render, staticRenderFns } from "./monitoringProducts.vue?vue&type=template&id=9dd87d24"
import script from "./monitoringProducts.vue?vue&type=script&lang=js"
export * from "./monitoringProducts.vue?vue&type=script&lang=js"
import style0 from "./monitoringProducts.vue?vue&type=style&index=0&id=9dd87d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports